import ExpandIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from '@mui/material';
import { Study } from 'interfaces/study';
import { filter, includes, isEmpty, keys, map } from 'lodash';
import React, { useMemo } from 'react';
import { useStainTypeOptions } from 'utils/queryHooks/uiConstantsHooks';
import { AddStain } from '../AddStain';
import { DeconvolutionStainMapping } from './DeconvolutionStainMapping';

export const DeconvolutionVisualizationSettings: React.FC<
  React.PropsWithChildren<{
    updatedSettings: Study['settings'];
    setUpdatedSettings: React.Dispatch<React.SetStateAction<Study['settings']>>;
  }>
> = ({ updatedSettings, setUpdatedSettings }) => {
  const updatedDeconvolutionSettings = updatedSettings.deconvolutionSettings;

  const updatedStainToComponentOperations = updatedDeconvolutionSettings?.stainToComponentOperation;

  const { stainTypeOptionsWithoutDeprecated } = useStainTypeOptions();

  const unassignedDeconvolutionStains = useMemo(
    () =>
      filter(
        stainTypeOptionsWithoutDeprecated,
        (stainType) => !updatedStainToComponentOperations?.[stainType?.id] && includes(stainType?.id, '_')
      ),
    [stainTypeOptionsWithoutDeprecated, updatedStainToComponentOperations]
  );

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandIcon />}>
        <Typography variant="h3">Deconvolution Visualization Settings</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid
          sx={{
            p: 2,
          }}
          container
          spacing={2}
        >
          <Grid item xs={12}>
            <Typography variant="h4">Deconvolution Operations</Typography>
          </Grid>
          <Grid item xs={12}>
            {map(keys(updatedStainToComponentOperations), (stainTypeId) => (
              <Grid item xs={12} key={stainTypeId}>
                <DeconvolutionStainMapping
                  stainTypeId={stainTypeId}
                  updatedSettings={updatedSettings}
                  setUpdatedSettings={setUpdatedSettings}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
        {!isEmpty(unassignedDeconvolutionStains) && (
          <AddStain
            unassignedDeconvolutionStains={unassignedDeconvolutionStains}
            setUpdatedSettings={(newStain: string) => {
              setUpdatedSettings({
                ...updatedSettings,
                deconvolutionSettings: {
                  ...updatedDeconvolutionSettings,
                  stainToComponentOperation: {
                    ...updatedStainToComponentOperations,
                    [newStain]: [],
                  },
                },
              });
            }}
          />
        )}
      </AccordionDetails>
    </Accordion>
  );
};
